import React from "react";
import { Button, Modal } from "react-bootstrap";

const InfoDialog = ({
  show,
  title = "Informasi",
  message = "",
  buttonLabel = "Tutup",
  onClose,
}) => {
  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{message}</Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={onClose}>
          {buttonLabel}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default InfoDialog;
